import Vue from "vue"

Vue.filter("daysToVote", (date) => {
    let seconds = Math.floor((new Date(date) - new Date(new Date().toUTCString().substr(0, 25))) / 1000);
    let interval = seconds / 86400;
    interval = seconds / 86400;
    if (interval > 1) {
        return Math.floor(interval) + " days left";
    }
    interval = seconds / 3600;
    if (interval > 1) {
        return Math.floor(interval) + " hours left";
    }
    interval = seconds / 60;
    if (interval > 1) {
        return Math.floor(interval) + " minutes left";
    }
    return Math.floor(seconds) + " seconds left";
})
